import { Disclosure } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import classNames from "classnames";
import React, { ReactNode } from "react";

interface IProps {
  title: ReactNode;
  titleIcon?: any;
  styles?: {
    container?: string;
    button?: string;
    panel?: string;
    bottomBorder?: boolean;
  };
  children: any;
  defaultOpen?: boolean;
}

export function Accordion({
  title,
  styles = {
    container: "",
    button: "",
    panel: "",
    bottomBorder: true,
  },
  children,
  titleIcon,
  defaultOpen = false,
}: IProps) {
  return (
    <div className={styles.container || ""}>
      <Disclosure defaultOpen={defaultOpen}>
        {({ open }) => (
          <>
            <Disclosure.Button
              as="button"
              className={classNames(
                open ? " border-gray-200" : "bg-gray-100",
                styles.button,
                styles.bottomBorder
                  ? "border-b"
                  : "w-full flex items-center justify-between",
              )}
            >
              <div className="flex items-center">
                {!!titleIcon && titleIcon}
                {title}
              </div>

              <ChevronRightIcon
                className={classNames(
                  open ? "rotate-90 transform" : "",
                  "w-4 h-4 text-gray-400",
                )}
              />
            </Disclosure.Button>

            <Disclosure.Panel className={styles.panel}>
              {children}
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
    </div>
  );
}
